import instance from "lib/axios";

export function uploadFile(file: File, config = {}) {
  const formData = new FormData();

  formData.append("asset", file);

  return instance.put("/storage", formData, config);
}
